import Timeline from './pages/Timeline';
import Detail from './pages/Detail';
import Success from './pages/Success';
import Pay from './pages/Pay';


export default [
	{
		path:'/',
		redirect:'/list'
	},{
	  path:'/list',
	  component:Timeline
	},{
		path:'/detail',
		component:Detail,
		name:"meetDetail"
	},{
		path:'/success',
		component:Success
	},{
		path:'/Pay',
		component:Pay
	}
]



// WEBPACK FOOTER //
// ./src/routes.js